module.exports = __webpack_public_path__ + "media/assets/images/flags/gs-1d909d7103298d0e8cbda969163f320e.svg";